export const LIST_PAYMENT_LINKS = 'LIST_PAYMENT_LINKS';
export const LIST_PAYMENT_STATISTIC = 'LIST_PAYMENT_STATISTIC';
export const LIST_CREATOR = 'LIST_CREATOR';
